// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vq-0";
export var checkoutRateBadgeLink = "_vq-1";